import Carousel from 'react-bootstrap/Carousel';
import LazyLoadingPhoto from './LazyLoadingPhoto';

function PhotoLabelCarousel({photos}) {
  let elements = [];
  photos.forEach((photo) => {
    if (photo.description)
      elements.push(
        <Carousel.Item>
          <LazyLoadingPhoto base={photo.name} />
          <Carousel.Caption>
            <p>{photo.description}</p>
          </Carousel.Caption>
        </Carousel.Item>
      )
      else
        elements.push(
          <Carousel.Item>
            <LazyLoadingPhoto base={photo.name} />
          </Carousel.Item>
        )
  })
  return (
    <Carousel>
      {elements}
    </Carousel>
  );
}

export default PhotoLabelCarousel;